import api from './api'

export interface LoginCredentials {
  identifier: string
  password: string
}

export interface AuthResponse {
  access_token: string
  refresh_token: string
}

const TOKEN_KEY = 'token'
const REFRESH_KEY = 'refresh_token'

export const authService = {
  async login(credentials: LoginCredentials): Promise<{ access_token: string; user?: any }> {
    const response = await api.post<AuthResponse>('/auth/login', credentials)
    const { access_token, refresh_token } = response.data
    if (access_token) {
      localStorage.setItem(TOKEN_KEY, access_token)
      if (refresh_token) localStorage.setItem(REFRESH_KEY, refresh_token)
      try {
        const profileResponse = await api.get('/profile')
        return { access_token, user: profileResponse.data.user }
      } catch {
        return { access_token }
      }
    }
    return { access_token }
  },

  async logout(): Promise<void> {
    const refresh_token = localStorage.getItem(REFRESH_KEY)
    // Limpiar siempre, incluso si la llamada al backend falla.
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(REFRESH_KEY)
    if (refresh_token) {
      try {
        await api.post('/auth/logout', { refresh_token })
      } catch {
        // El servidor pudo fallar; ya limpiamos local. Idempotente.
      }
    }
  },

  /**
   * Renueva access_token usando el refresh_token. Llamado por el interceptor
   * cuando un request devuelve 401 con un access token presumiblemente expirado.
   * El backend rota el refresh: el viejo queda revocado y devuelve uno nuevo.
   */
  async refresh(): Promise<string | null> {
    const refresh_token = localStorage.getItem(REFRESH_KEY)
    if (!refresh_token) return null
    const response = await api.post<AuthResponse>('/auth/refresh', { refresh_token })
    const { access_token, refresh_token: newRefresh } = response.data
    if (!access_token) return null
    localStorage.setItem(TOKEN_KEY, access_token)
    if (newRefresh) localStorage.setItem(REFRESH_KEY, newRefresh)
    return access_token
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem(TOKEN_KEY)
  },

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY)
  },

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_KEY)
  },
}
